import { ALL_DATA_TYPES } from 'advanced-filters/data';
import { LeadSystemAttributeSchemaName } from 'crm-atoms/data';

export const getParsedDataTypeBySchemaName = (defaultDataType: string, schemaName: string) => {
  if (schemaName === LeadSystemAttributeSchemaName.leadStage) {
    return ALL_DATA_TYPES.reference_lead_stage;
  } else if (schemaName === LeadSystemAttributeSchemaName.leadSource) {
    return ALL_DATA_TYPES.reference_lead_source;
  }
  return defaultDataType;
};
